export default __webpack_public_path__ + "static/media/21.7f19d8c7.jpg";